var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEnquiry = function SvgEnquiry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#enquiry_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.65 0c.619.001 1.212.25 1.65.693.438.443.684 1.043.685 1.669V3.61h2.68c.619.002 1.212.25 1.65.693.438.442.684 1.043.685 1.669v11.666c0 .626-.247 1.226-.685 1.669a2.327 2.327 0 0 1-1.65.693H2.336a2.329 2.329 0 0 1-1.65-.693A2.377 2.377 0 0 1 0 17.639V5.972c0-.626.247-1.227.685-1.67a2.328 2.328 0 0 1 1.651-.692h2.68V2.362c0-.626.246-1.226.684-1.669A2.33 2.33 0 0 1 7.351 0h5.299ZM1.613 11.725v5.914c0 .193.076.38.212.517.135.137.32.214.511.214h15.329a.72.72 0 0 0 .51-.214.737.737 0 0 0 .213-.517v-5.914H1.613Zm.723-6.485a.722.722 0 0 0-.511.215.737.737 0 0 0-.212.517v4.124h16.775V5.972a.737.737 0 0 0-.213-.517.72.72 0 0 0-.51-.215H2.336Zm9.323 2.301c.213 0 .419.086.57.239a.819.819 0 0 1 0 1.152.804.804 0 0 1-.57.239H8.34a.803.803 0 0 1-.57-.239.819.819 0 0 1-.235-.576.82.82 0 0 1 .235-.576.803.803 0 0 1 .57-.239h3.318ZM7.35 1.63a.722.722 0 0 0-.51.214.737.737 0 0 0-.212.517v1.25h6.744V2.36a.736.736 0 0 0-.211-.517.721.721 0 0 0-.512-.214H7.35Z",
    fill: "#018DD7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "enquiry_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};

export default SvgEnquiry;